import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';



@Injectable()

export class ORCustomerVehicleService {
    vehicleWithOR: boolean = false;

    constructor(private http: HttpClient) { }

    getCustomerOR(customerCode) {
        const url = `${environment.ENTORNO}${environment.SessionService.URL_General}GetCustomerDocuments`;
        const params = {
            customerCode: customerCode
        };
        let customerWithOR: boolean = false;
        let customerORList: any[] = [];
        return this.http.post(url, params).pipe(map((data: any) => {
            const auxdata = data.Response;
            if (auxdata && auxdata.length > 0) {
                    customerWithOR = true;
                    customerORList = auxdata;
            } else{
                customerWithOR = false;
                customerORList = [];
            }
            return { customerWithOR, customerORList };
        }))
    }

	getVehicleOR(chassis) {
        const url = `${environment.ENTORNO}${environment.SessionService.URL_GESTION_VEHICULOS}GetCarDocuments`;
        const params = {
            chassis: chassis
        };
        let vehicleWithOR: boolean = false;
        let vehicleORList: any[] = [];
        return this.http.post(url, params).pipe(map((data: any) => {
            const auxdata = data.Response;
            if (auxdata && auxdata.length > 0) {
                    vehicleWithOR = true;
                    vehicleORList = auxdata;
            } else{
                vehicleWithOR = false;
                vehicleORList = [];
            }
            return { vehicleWithOR, vehicleORList }
        }))
    }

    updateCustomerOR(customerCode){
        const url = `${environment.ENTORNO}${environment.SessionService.URL_General}UpdateCustomerDataInDocumentsByCustomerCode`;
        const params = {
            customerCode: customerCode
        }
        return this.http.post(url, params).pipe(map((data: any) => {
            return data;
        }))
    }

    updateVehicleOR(chassis){
        const url = `${environment.ENTORNO}${environment.SessionService.URL_GESTION_VEHICULOS}UpdateCarDataByChassis`;
        const params = {
            chassis: chassis
        }
        return this.http.post(url, params).pipe(map((data: any) => {
            return data;
        }))
    }
}
